
import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import Home from '../Home';
import Thankyou from '../Component/Thankyou/Thankyou';
import UploadPrescription from '../Component/UploadPrescription/UploadPrescription';
import Brochure from '../Component/Brochure/Brochure';
import Team from '../Component/Team/Team';
import SignUp from '../SignUp';
import Departments from '../Component/Departments/Departments';
import Overview from '../Component/Overview/Overview';
import BookATest from '../Component/BookATest/BookATest';
import BookAPackage from '../Component/BookAPackage/BookAPackage';
import Labs from '../Component/labs';
import DepartmentDetails from '../Component/departmentDetail';
import DoctorDetails from '../Component/doctorDetail';
import PillarsOfEndeavour from '../Component/endeavour';
import DownloadReport from '../Component/DownloadReport/DownloadReport';
import LabsDetails from '../Component/labDetail';
import GeneralEnquiry from '../Component/GeneralEnquiry/GeneralEnquiry';
import { ROUTE } from './Route';
import TestPackageDetails from '../Component/packageDetail';
import Offer from '../Component/Offer/Offer';
import Faq from '../Component/faq/Faq';
import CheckOut from '../Component/Checkout/CheckOut';
import CorporateOffice from '../Component/CorporateOffice/CorporateOffice';
import SearchForTest from '../Component/SearchForTest/SearchForTest';
import NewsUpdates from '../Component/NewsUpdate/Newsupdate';
import NewsUpdatesDetail from '../Component/NewsUpdateDetail';
import CustomLanding from '../Component/customLandingPage';
import NationalRefLab from '../Component/NationalLaboratry';
import QualityManagement from '../Component/qualityManagement';
import Ecme from '../Component/Ecme';
import Career from '../Component/Career';
import DirectorMessage from '../Component/DirectorMessage';
import Accreditations from '../Component/Accreditation';
import AwardRecognition from '../Component/awardRecog';
import EcmeDetails from '../Component/EcmeDetails';
import TestDetails from '../Component/TestDetails';
import PackageDetails from '../Component/packageDetail';
import PressRealeaseDetails from '../Component/PressRealeaseDetails';
import TermsAndConditon from '../Component/TermsAndConditon/TermsAndConditon';
import Disclaimer from '../Component/Disclaimer/Disclaimer';
import PrivacyPolicy from '../Component/PrivacyPolicy/PrivacyPolicy';
import HealthEnquiry from '../Component/HealthEnquiry/HealthEnquiry';
import HomeCollectionForm from '../Component/HomeCollectionForm';
import BecomeVendor from '../Component/BecomeVendor';
import BecomePartner from '../Component/BecomePartner';
import Testimonials from '../Component/Testimonials/Testimonials';
import PreventiveHealthPackage from '../Component/preventiveHealthPackage/PreventiveHealthPackage';
// import PreventiveHealthPackageDetails from '../Component/preventiveHealthPackage/Details';
import Neurology from '../Component/Neurology/Neurology';
import Allergy from '../Component/Allergy/Allergy';
import Mamaprint from '../Component/Mamaprint/Mamaprint';
import LandingPages from '../Component/LandingPages/LandingPages';
import GurugramLab from '../Component/GurugramLab';
import BengaluruLab from '../Component/BengaluruLab';
import KolakataLab from '../Component/KolakataLab';
import Cancer from '../Component/Cancer/Cancer';
import PrenatalTesting from '../Component/PrenatalTesting/PrenatalTesting';
import LudhianaLab from '../Component/LudhianaLab/LudhianaLab';
import VideoSection from '../Component/VideoSection/VideoSection';
import ClinicalTrial from '../Component/ClinicalTrial';
import PrivilegeMembershipCard from '../Component/PrivilegeMembershipCard';
import PrivilegeMembershipCardDoctor from '../Component/PrivilegeMembershipCardDoctor';
import PathlogyTest from '../Component/PathlogyTest/PathlogyTest';
import PathlogyTestCity from '../Component/PathlogyTestCity/PathlogyTestCity';
import PathlogyTestLocal from '../Component/PathlogyTestLocal/PathlogyTestLocal';
import TestDetailsCity from '../Component/TestDetailsCity';
import TestDetailsLocality from '../Component/TestDetailsLocality';
import Sitemap from '../Component/Sitemap/Sitemap';
import errorPage from '../Component/ErrorPage';
import MyProfile from '../Component/MyProfile';
import PaymentThankyou from '../Component/PaymentThankyou';
import LoginPage from '../Component/Login/LoginPage';
import { getUser } from '../constant/utils';


function AppRoute() {
  const USER: any = getUser();
  return (
    <Switch>
      <Route exact path={ROUTE.LOGIN} render={() => (
          USER?.Id ? <Redirect to={ROUTE.MYPROFILE} /> : <LoginPage />
        )}/>
      <Route exact path={ROUTE.HOME} component={Home} />
      <Route exact path={ROUTE.THANKYOU} component={Thankyou} />
      <Route exact path={ROUTE.UPLOADPRESCRIPTION} component={UploadPrescription} />
      <Route exact path={ROUTE.UPLOADPRESCRIPTION}>
          <Redirect to="/" />
      </Route>
      <Route exact path={ROUTE.BROCHURES} component={Brochure} />
      <Route exact path={ROUTE.SIGNUP} component={SignUp} />
      <Route exact path={ROUTE.DEPARTMENTDETAILS + "/:slug"} component={DepartmentDetails} />
      <Route exact path={ROUTE.DEPARTMENT} component={Departments} />
      <Route exact path={ROUTE.BOOKATEST + "/:subCategorySlug?"} component={BookATest} />
      <Route exact path={ROUTE.BOOKAPACKAGE} component={BookAPackage} />
      <Route exact path={ROUTE.TESTDETAILS + "/:slug"} component={TestDetails} />
      <Route exact path={ROUTE.PACKAGEDETAILS + "/:slug"} component={PackageDetails} />
      <Route exact path={ROUTE.CENTERDETAILS + "/:slug"} component={LabsDetails} />
      <Route exact path={ROUTE.CENTER} component={Labs} />
      <Route exact path={ROUTE.DOCTORDETAILS + "/:slug"} component={DoctorDetails} />
      <Route exact path={ROUTE.DOWNLOADREPORT} component={DownloadReport} />
      <Route exact path={ROUTE.GENERALENQUIRY} component={GeneralEnquiry} />
      <Route exact path={ROUTE.OFFER} component={Offer} />
      <Route exact path={ROUTE.NEWSANDUPDATESDETAIL + "/:slug"} component={NewsUpdatesDetail} />
      <Route exact path={ROUTE.PRESSREALEASEDETAIL + "/:slug"} component={PressRealeaseDetails} />
      <Route exact path={ROUTE.NEWSANDUPDATES} component={NewsUpdates} />
      <Route exact path={ROUTE.FAQ} component={Faq} />
      <Route exact path={ROUTE.CHECKOUT} component={CheckOut} />
      <Route exact path={ROUTE.CORPORATEOFFICE} component={CorporateOffice} />
      <Route exact path={ROUTE.SERACHFORTEST} component={SearchForTest} />
      <Route exact path={ROUTE.CUSTOMLANDING} component={CustomLanding} />
      <Route exact path={ROUTE.NATIONREFLAB} component={NationalRefLab} />
      <Route exact path={ROUTE.ECME} component={Ecme} />
      <Route exact path={ROUTE.ECME + "/:slug"} component={EcmeDetails} />
      <Route exact path={ROUTE.CAREER} component={Career} />
      <Route exact path={ROUTE.CAREER}>
          <Redirect to="/" />
      </Route>
      <Route exact path={ROUTE.DIRECTORMESSAGE} component={DirectorMessage} />
      <Route exact path={ROUTE.OVERVIEW} component={Overview} />
      <Route exact path={ROUTE.ENDEVOUR} component={PillarsOfEndeavour} />
      <Route exact path={ROUTE.TEAM} component={Team} />
      <Route exact path={ROUTE.ACCREDATITION} component={Accreditations} />
      <Route exact path={ROUTE.QUALITYMANAGEMENT} component={QualityManagement} />
      <Route exact path={ROUTE.AWARD} component={AwardRecognition} />
      <Route exact path={ROUTE.PRIVACY} component={PrivacyPolicy} />
      <Route exact path={ROUTE.DISCLAIMER} component={Disclaimer} />
      <Route exact path={ROUTE.TERMSCONDITION} component={TermsAndConditon} />
      <Route exact path={ROUTE.HEALTHENQUIRY} component={HealthEnquiry} />
      <Route exact path={ROUTE.HOMECOLLECTION} component={HomeCollectionForm} />
      <Route exact path={ROUTE.BLOODSAMPLEHOMECOLLECTION} component={HomeCollectionForm} />
      <Route exact path={ROUTE.BECOMEVENDOR} component={BecomeVendor} />
      <Route exact path={ROUTE.BECOMWEPARTNER} component={BecomePartner} />
      <Route exact path={ROUTE.TESTIMONIAL} component={Testimonials} />
      <Route exact path={ROUTE.PREVENTIVEHEALTHPKJ} component={PreventiveHealthPackage} />
      {/* <Route exact path={ROUTE.PREVENTIVEHEALTHPKJ + "/:slug"} component={PreventiveHealthPackageDetails} /> */}
      <Route exact path={ROUTE.NEUROLOGY} component={Neurology} />
      <Route exact path={ROUTE.ALLERGY} component={Allergy} />
      <Route exact path={ROUTE.QUICKLINKS} component={LandingPages} />
      <Route exact path={ROUTE.MAMAPRINT} component={Mamaprint} />
      <Route exact path={ROUTE.GURUGRAMLAB} component={GurugramLab} />
      <Route exact path={ROUTE.BENGALURULAB} component={BengaluruLab} />
      <Route exact path={ROUTE.KOLKATALAB} component={KolakataLab} />
      <Route exact path={ROUTE.CANCER} component={Cancer} />
      <Route exact path={ROUTE.PRENATALTESTING} component={PrenatalTesting} />
      <Route exact path={ROUTE.LUDHIANALAB} component={LudhianaLab} />
      <Route exact path={ROUTE.VIDEOSECTION} component={VideoSection} />
      <Route exact path={ROUTE.CLINICALTRIAL} component={ClinicalTrial} />
      <Route exact path={ROUTE.PRIVILEGEMEMBERSHIP} component={PrivilegeMembershipCard} />
      <Route exact path={ROUTE.PRIVILEGEMEMBERSHIPDOCTOR} component={PrivilegeMembershipCardDoctor} />
      <Route exact path={ROUTE.MYPROFILE} component={MyProfile} />
      <Route exact path={ROUTE.MYPROFILE + "/:slug"} component={MyProfile} />
      <Route exact path={ROUTE.PAYMENT_THANKYOU} component={PaymentThankyou} />
      <Route exact path={ROUTE.PATHLOGYTEST} component={PathlogyTest} />
      <Route exact path={ROUTE.PATHLOGYTEST + "/:slug" } component={PathlogyTestCity} />
      <Route exact path={ROUTE.PATHLOGYTEST + "/:slug" + "/:locality"} component={PathlogyTestLocal} />
      <Route exact path={ROUTE.TESTDETAILS + "/:slug" + "/:cityslug"} component={TestDetailsCity} />
      <Route exact path={ROUTE.TESTDETAILS + "/:slug" + "/:cityslug" + "/:locality"} component={TestDetailsLocality} />
      {/* <Route exact path={ROUTE.DIAGNOSTICCENTERSCITY + "/:slug"} component={DiagnosticCentresCity} />
      <Route exact path={ROUTE.CENTERDETAILSDIAGNOSTIC + "/:cityslug" + "/:slug"} component={LabsDetailsDiagnostic} /> */}
      <Route exact path={ROUTE.SITEMAP} component={Sitemap} />
      <Route path="*" component={errorPage} />
    </Switch>
  );
}

export default AppRoute;
